/** disputes group: disputes and coverage claims (docs/03 "Vocabulary"). A WP adds to its own group and to docs/03 in the same commit. */
export const disputesPermissions = ['dispute:read', 'dispute:manage', 'claim:file'] as const;

export type DisputesPermission = (typeof disputesPermissions)[number];
